import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ActivationEnum } from '../../core/enums/generated/ActivationEnum';
import { ActivationVm } from '../generated/Models/ActivationVm';
import { SystemMessageService } from '../../core/system-message/system-message-service';

@Injectable({
    providedIn: 'root'
})
export class ActivationService {

    constructor(private ms: SystemMessageService) {}

    activateDeactivate(
        id: any
        , activationEnum: ActivationEnum
        , isActive: boolean
    ) {
        const model = new ActivationVm();
        model.id = id;
        model.activationEnum = activationEnum;
        model.isActive = isActive;
        const activationForm : UntypedFormGroup = ActivationVm.Form;
        activationForm.setValue(model);

        this.ms.getHttpObservable(this, 'api/Activation/ActivateDeactivate', activationForm).subscribe();
    }
}
